import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "text-input" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "zip",
  class: "body-text"
}, "Postal/Zip Code", -1)
const _hoisted_9 = { class: "row mt-20" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("small", null, "IATSE NBF Accepts VISA or Mastercard", -1)
const _hoisted_12 = { class: "row mt-20" }
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "text-input" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "cardholderFirstName",
  class: "body-text"
}, "Cardholder's First Name", -1)
const _hoisted_16 = { class: "row mt-20" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "text-input" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "cardholderLastName",
  class: "body-text"
}, "Cardholder's Last Name", -1)
const _hoisted_20 = { class: "row mt-20" }
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = { class: "row mt-20" }
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = { class: "col-6" }
const _hoisted_25 = { class: "text-input" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "cvv",
  class: "body-text"
}, "CVV", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-20" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "submit",
      class: "btn btn-primary"
    }, "Pay Now")
  ])
], -1)
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "cobra-summary" }
const _hoisted_30 = { class: "primary-table" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Invoice"),
    /*#__PURE__*/_createElementVNode("th", null, "Coverage Period"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount Due")
  ])
], -1)
const _hoisted_32 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, "Additional Amount", -1)
const _hoisted_34 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, "Total Amount", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_CardNumberField = _resolveComponent("CardNumberField")!
  const _component_CardExpirationField = _resolveComponent("CardExpirationField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => ($setup.payCobra && $setup.payCobra(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "zip",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.zip) = $event)),
                    class: "links"
                  }, null, 512), [
                    [_vModelText, $setup.zip]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_SelectComponent, {
                  label: "Card Type",
                  modelValue: $setup.cardType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.cardType) = $event)),
                  options: $setup.cardOptions
                }, null, 8, ["modelValue", "options"]),
                _hoisted_11
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "cardholderFirstName",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.cardholderFirstName) = $event)),
                    class: "links"
                  }, null, 512), [
                    [_vModelText, $setup.cardholderFirstName]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "cardholderLastName",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.cardholderLastName) = $event)),
                    class: "links"
                  }, null, 512), [
                    [_vModelText, $setup.cardholderLastName]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_CardNumberField, {
                  modelValue: $setup.cardNumber,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.cardNumber) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_CardExpirationField, {
                  modelValue: $setup.cardExpiration,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.cardExpiration) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "cvv",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.cvv) = $event)),
                    placeholder: "Add CVV",
                    class: "links"
                  }, null, 512), [
                    [_vModelText, $setup.cvv]
                  ])
                ])
              ])
            ]),
            _hoisted_27
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("table", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedInvoicesDetails, (invoice, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(invoice.PlanName), 1),
                    _createElementVNode("td", null, _toDisplayString(invoice.InsuranceStartDate +
                                        " - " +
                                        invoice.InsuranceEndDate), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.formatCurrency(invoice.Amount)), 1)
                  ]))
                }), 128))
              ])
            ]),
            ($setup.payInAdvanceSelected)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("h4", null, _toDisplayString($setup.payInAdvance !== null ? $setup.formatCurrency($setup.payInAdvance) : 0), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("h4", null, _toDisplayString($setup.formatCurrency($setup.total)), 1)
            ]),
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => ($setup.closeLastModal && $setup.closeLastModal(...args)), ["prevent"])),
              class: "btn btn-primary"
            }, "Edit COBRA Payment")
          ])
        ])
      ])
    ])
  ]))
}